var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rooms one-component-detail-admin"},[_c('div',{staticClass:"title-component-admin"},[_vm._v("Hạng phòng")]),_c('el-form',{staticClass:"p-3",attrs:{"model":_vm.form}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }